<template>
  <div class="pagesMainDiv">

    <div class="pageHeader" style="margin-bottom: 15px;">
      <h1 tabindex="0" class="pageHeader">Create New Person </h1><span  tabindex="0" class="divRequiredInstructions">* Indicates a required field</span>
      <span v-if="validationErrorsFound" class="divRequiredInstructions"> ( <span class="highlightRed">!!</span> shows fields with issues)</span>
    </div>

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Form ------------------------------- -->
      <!-- ---------------------------------------------------------------- -->

    <div class="formContainer" style="min-width: 1350px;">

      <!-- --------------------------------------------- -->
      <!-- ------------ left column -------------------- -->
      <!-- --------------------------------------------- -->

      <!-- <div class="detailFormContainer"> -->

        <div class="leftRightRowContainer">

            <!-- ----------------- First Name -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">First Name:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom">
                <div><input tabindex="0" type="text" v-model="selectedFirstName" maxlength="30" id="txtFirstNameID" class=" ctrlSize27 ctrlBorderRadius ctrlTextbox fontSizeAll" aria-label="Enter your first name" aria-live="polite" aria-required="true"></div>
                <span v-if="!firstNameUndefined" class="validationErrorAsterisk">*</span>
                <span v-if="firstNameUndefined" class="highlightRed validationErrorAsterisk">!!</span>
            </div>

            <!-- ----------------- Middle Name -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">Middle Name:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom borderRight">
                <div><input tabindex="0" type="text" v-model="selectedMiddleName" maxlength="31" id="txtMiddleNameID" class=" ctrlSize27 ctrlBorderRadius ctrlTextbox fontSizeAll" aria-label="Enter your Middle Name" aria-live="polite"></div>
            </div>

            <!-- ----------------- Last Name ------->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">Last Name:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom borderRight">
                <div>
                    <input tabindex="0" type="text" id="txtLastNameID" v-model="selectedLastName" maxlength="100" class="ctrlSize27 ctrlBorderRadius ctrlTextbox fontSizeAll" aria-label="Enter your Last Name" aria-live="polite" aria-required="true">
                    <span v-if="!lastNameUndefined" class="validationErrorAsterisk">*</span>
                    <span v-if="lastNameUndefined" class="highlightRed validationErrorAsterisk">!!</span>
                </div>

                <!-- ----------------- Suffix ------->
                <div>
                    <span class="labelRightMargin ctrlLabel  fontSizeAll" style="margin-left: 20px;">Suffix:</span> <input tabindex="0" class=" ctrlBorderRadius ctrlTextbox fontSizeAll" aria-label="Enter a suffix" aria-live="polite"
                                                                                                                           type="text" v-model="selectedSuffix" maxlength="3" id="txtLastName" size="2">
                </div>
            </div>

            <!-- ----------------- Passport / Taskera / NIN -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">Passport / Taskera / NIN:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom">
                <div><input tabindex="0" type="text" v-model="selectedPassport" maxlength="30" id="txtPassportID" class=" ctrlSize27 ctrlBorderRadius ctrlTextbox fontSizeAll" aria-label="Enter your passport/taskera/national ID" aria-live="polite" aria-required="true"></div>
                <span v-if="!passportUndefined" class="validationErrorAsterisk">*</span>
                <span v-if="passportUndefined" class="highlightRed validationErrorAsterisk">!!</span>
            </div>

            <!-- ----------------- Email -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">Email:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom">
                <div><input tabindex="0" type="Email" v-model="selectedEmail" maxlength="125" id="txtEmailID" class=" ctrlSize27 ctrlBorderRadius ctrlTextbox fontSizeAll" aria-label="Enter your email address" aria-live="polite"></div>
            </div>

            <!-- ----------------- Nationality -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">Nationality:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom borderRight">

                <select tabindex="0" id="NationalityID" class="ctrlBorderRadius ctrlDropDown fontSizeAll"
                        v-model="selectedNationalityID" aria-label="Select a nationality from the drop down list" aria-required="true">
                    <option v-for="item in nationalityList" :value="item.countryId" :key="item.countryId">
                        {{ item.countryName }}
                    </option>
                </select>

                <span v-if="!nationalityUndefined" class="validationErrorAsterisk">*</span>
                <span v-if="nationalityUndefined" class="highlightRed validationErrorAsterisk">!!</span>
            </div>

            <!-- ----------------- Contract -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">Contract:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom borderRight">

                <select tabindex="0"
                        aria-label="Select a contract from the drop down list" aria-required="true"
                        id="ContractID"
                        :disabled="disableContractDdl"
                        class="ctrlBorderRadius ctrlDropDown fontSizeAll"
                        v-model="selectedContractID">
                    <option v-for="item in contractList" :value="item.contractId" :key="item.contractId">
                        {{ item.contractNumber }}
                    </option>
                </select>
                <span v-if="!contractUndefined && (disableContractDdl == false)" class="validationErrorAsterisk">*</span>
                <span v-if="contractUndefined && (disableContractDdl == false)" class="highlightRed validationErrorAsterisk">!!</span>
            </div>

            <!-- ----------------- Employer -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">Employer:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom borderRight">

                <select tabindex="0" id="CompanyId" class="ctrlBorderRadius ctrlDropDown fontSizeAll"
                        v-model="selectedCompanyId" aria-label="Select your employer from the drop down list" aria-required="true">
                    <option v-for="item in companyList" :value="item.companyId" :key="item.companyId">
                        {{ item.companyName }}
                    </option>
                </select>
                <span v-if="!employerUndefined" class="validationErrorAsterisk">*</span>
                <span v-if="employerUndefined" class="highlightRed validationErrorAsterisk">!!</span>
            </div>


        </div>

      <!-- </div> -->

      <!-- ---------------------------------------------- -->
      <!-- ------------ right column -------------------- -->
      <!-- ---------------------------------------------- -->

        <div class="leftRightRowContainer">

            <!-- ----------------- LOA -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">LOA:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom">
                <div><input tabindex="0" type="text" v-model="selectedLoa" maxlength="10" id="txtLoaID" class=" ctrlSize27 ctrlBorderRadius ctrlTextbox fontSizeAll" aria-label="Enter the LOA number" aria-live="polite" aria-required="true"></div>
                <span v-if="!loaUndefined" class="validationErrorAsterisk">*</span>
                <span v-if="loaUndefined" class="highlightRed validationErrorAsterisk">!!</span>
            </div>

            <!-- ----------------- LOA - AW -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">LOA - AW:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom">

                <select tabindex="0" id="LoaAwID" class="ctrlBorderRadius ctrlDropDown fontSizeAll"
                        v-model="SelectedLoaawID" aria-label="Indicate if your LOA allows you to be armed by selecting a value from the drop down list" aria-live="polite" aria-required="true">
                    <option v-for="item in LoaawList" :value="item.id" :key="item.id">
                        {{ item.itemValue }}
                    </option>
                </select>

            </div>

            <!-- ----------------- DOD Civ -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">DOD Civ:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom">

                <select tabindex="0" id="DODVivID" class="ctrlBorderRadius ctrlDropDown fontSizeAll"
                        v-model="SelectedDodCivID" aria-label="Are you a DOD Civilian? Select a value from the drop down list" aria-live="polite" aria-required="true">
                    <option v-for="item in DodCivList" :value="item.id" :key="item.id">
                        {{ item.itemValue }}
                    </option>
                </select>
                <span v-if="!dodCivUndefined" class="validationErrorAsterisk">*</span>
                <span v-if="dodCivUndefined" class="highlightRed validationErrorAsterisk">!!</span>
            </div>


            <!-- ----------------- In Theater -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">In Theater:</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom borderRight ">
                <input tabindex="0" id="inTheaterID" type="date" class="ctrlBorderRadius ctrlDate fontSizeAll" v-model="SelectedInTheaterDate" aria-label="Enter the date you arrived in theater" aria-live="polite" aria-required="true" />
            </div>

            <!-- ----------------- Deploy Start (from LOA) -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">Deploy Start (from LOA):</div>
            </div>
            <div class="itemHorLeftVerCenter  borderBottom borderRight">
                <input tabindex="0" ID="DeployStartLoaID" type="date" class="ctrlBorderRadius ctrlDate fontSizeAll" v-model="SelectedDeployStartDate" aria-label="Enter your deployment start date" aria-live="polite" aria-required="true" />
                <span v-if="!deployStartUndefined && !endNotGreaterThanStart" class="validationErrorAsterisk">*</span>
                <span v-if="deployStartUndefined || endNotGreaterThanStart" class="highlightRed validationErrorAsterisk">!!</span>
            </div>

            <!-- ----------------- Deploy End (from LOA) -->
            <div class="itemHorRightVerCenter borderBottom">
                <div class="labelRightMargin ctrlLabel  fontSizeAll">Deploy End (from LOA):</div>
            </div>
            <div class="itemHorLeftVerCenter borderBottom">
                <input tabindex="0" ID="DeployEndLoaID" type="date" class="ctrlBorderRadius ctrlDate fontSizeAll" v-model="selectedDeployEndLOA" aria-label="Enter your deployment end date" aria-live="polite" aria-required="true" />
                <span v-if="!deployEndUndefined && !endNotGreaterThanStart" class="validationErrorAsterisk">*</span>
                <span v-if="deployEndUndefined || endNotGreaterThanStart" class="highlightRed validationErrorAsterisk">!!</span>
            </div>

        </div>

    </div>

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Validation ------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div  v-if="validationErrorsFound" class="validationDiv">

        <div tabindex="0" class="validationHeaderDiv">Form Validation</div>

        <table class="valTable valTableMargin">
          <tr>
            <td tabindex="0"  style="text-align: center" colspan="2" class="highlightDarkRed" >The validation issues are the following:</td>
          </tr>
          <tr v-if="lastNameUndefined">
            <td tabindex="0" class="valCellLeft fontSizeAll" >Last Name</td>
            <td tabindex="0" class="valCell fontSizeAll">Field is blank</td>
          </tr>
          <tr v-if="firstNameUndefined">
            <td tabindex="0" class="valCellLeft fontSizeAll">First Name</td>
            <td tabindex="0" class="valCell fontSizeAll">Field is blank</td>
          </tr>
          <tr v-if="passportUndefined">
            <td tabindex="0" class="valCellLeft fontSizeAll">Passport / Taskera / NIN</td>
            <td tabindex="0" class="valCell fontSizeAll">Field is blank</td>
          </tr>
          <tr v-if="nationalityUndefined">
            <td tabindex="0" class="valCellLeft fontSizeAll">Nationality</td>
            <td tabindex="0" class="valCell fontSizeAll">Field is blank</td>
          </tr>
          <tr v-if="contractUndefined">
            <td tabindex="0" class="valCellLeft fontSizeAll">Contract</td>
            <td tabindex="0" class="valCell fontSizeAll">Field is blank</td>
          </tr>
          <tr v-if="employerUndefined">
            <td tabindex="0" class="valCellLeft fontSizeAll">Employer</td>
            <td tabindex="0" class="valCell fontSizeAll">Field is blank</td>
          </tr>
          <tr v-if="deployStartUndefined">
            <td tabindex="0" class="valCellLeft fontSizeAll">Deploy Start (from LOA)</td>
            <td tabindex="0" class="valCell fontSizeAll">Field is blank</td>
          </tr>
          <tr  v-if="deployEndUndefined">
            <td tabindex="0" class="valCellLeft fontSizeAll">Deploy End (from LOA)</td>
            <td tabindex="0" class="valCell fontSizeAll">Field is blank</td>
          </tr>
          <tr  v-if="endNotGreaterThanStart">
            <td tabindex="0" class="valCellLeft fontSizeAll">Deploy Start and Deploy End</td>
            <td tabindex="0" class="valCell fontSizeAll">Deploy End not greater than Deploy Start</td>
          </tr>
          <tr v-if="loaUndefined">
            <td tabindex="0" class="valCellLeft fontSizeAll">LOA</td>
            <td tabindex="0" class="valCell fontSizeAll">Field is blank</td>
          </tr>
          <tr v-if="dodCivUndefined">
            <td tabindex="0" class="valCellLeft fontSizeAll">DOD Civ</td>
            <td tabindex="0" class="valCell fontSizeAll">Field is blank</td>
          </tr>
        </table>

      </div>

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Record Added ----------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div  v-if="showVerifiedPerson" class="validationDiv">

        <div tabindex="0" class="validationHeaderDiv">Person Successfully added to Database</div>

        <table class="valTable valTableMargin">
          <tr>
            <td tabindex="0" colspan="2" style="text-align: center" class="highlightDarkRed" >Subset of fields</td>
          </tr>
          <tr>
            <td tabindex="0" class="valCellLeft fontSizeAll">Person ID</td>
            <td tabindex="0" class="valCell fontSizeAll">{{ verifiedPersonID }}</td>
          </tr>
          <tr>
            <td tabindex="0" class="valCellLeft fontSizeAll" >Last Name</td>
            <td tabindex="0" class="valCell fontSizeAll">{{ verfiedLastname }}</td>
          </tr>
          <tr>
            <td tabindex="0" class="valCellLeft fontSizeAll">First Name</td>
            <td tabindex="0" class="valCell fontSizeAll">{{ verfiedFirstName }}</td>
          </tr>
          <tr>
            <td tabindex="0" class="valCellLeft fontSizeAll">Contract Number</td>
            <td tabindex="0" class="valCell fontSizeAll">{{ verfiedContract }}</td>
          </tr>
        </table>

        <button tabindex="0" class="btn btn-primary btnCreateProperties tbdButtonLeftMargin fontSizeBtn" 
              @click='handleHideResults' @keydown.enter="handleHideResults"
              id="tbnClearID"
              type="button">Hide Results</button>

      </div>
      
      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Action Controls -------------------- -->
      <!-- ---------------------------------------------------------------- -->

    <div class="pageHeader">
      <button class="btn btn-primary btnCreateProperties fontSizeBtn" 
              @click='handleCreatePersonFunc' 
              @keydown.enter='handleCreatePersonFunc' 
              tabindex="0"
              id="tbnCreateID"
              role="button"
              type="button">Create Person</button>

              <button class="btn btn-primary btnCreateProperties tbdButtonLeftMargin fontSizeBtn" 
              @click='handleClearFunc'
              @keydown.enter='handleClearFunc'
              tabindex="0"
              id="tbnClearID"
              role="button"
              type="button">Clear Form</button>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { store } from "../../store/store.js";

export default {
  data() {
    return {

      // ------------------- Role -----------------------

      userIsAdmin: false,

      // ------------------- Router Parameters -----------------------

      contractID: null,
      contractNumber: null,
      disableContractDdl: false,
      createdHasBeenExecuted: false,

      // ------------ Nationality
      // nationalityList: [
      //   { "id": 1, "itemValue": "SAINT HELENA, ASCENSION, AND TRISTAN DA CUNHA" }, 
      //   { "id": 2, "itemValue": "VIRGIN ISLANDS, BRITISH" },
      // ],
      nationalityList: null,
      selectedNationalityID: null,
      defaultCountry: { countryId: -1, countryName: 'Please Select a Value' },

      // ------------ Contract
      // contractList: [
      // { "id": 1, "itemValue": "HTC711-17-D-R016/HTC711-18-F-R029" }, 
      //   { "id": 2, "itemValue": "W912DY19F0064" },
      // ],
      contractList: null,
      defaultContract: { contractId: -1, contractNumber: 'Please Select a Value' },
      selectedContractID: null,

      // ------------ Company
      // companyList: [
      // { "id": 1, "itemValue": "Joint Improvised Explosive Device Defeat Organization" }, 
      //   { "id": 2, "itemValue": "GW Government Services Inc. (GW)" },
      // ],
      companyList: null,
      selectedCompanyId: null,
      defaultCompany: { 
        companyId: -1, 
        companyName: 'Please Select a Value' 
      },

      // ------------ LOA-AW
      LoaawList: [
      { "id": -1, "itemValue": "Please Select a Value" }, 
      { "id": 1, "itemValue": "Yes" }, 
      { "id": 2, "itemValue": "No" },
      ],
      SelectedLoaawID: 1,
      DefaultLoaawID: -1,

      // ------------ DOD Civ
      DodCivList: [
      { "id": -1, "itemValue": "Please Select a Value" }, 
      { "id": 1, "itemValue": "Yes" }, 
      { "id": 2, "itemValue": "No" },
      ],
      SelectedDodCivID: 2,
      DefaultDodCivID: -1,

      // ------------ Dates
      SelectedDeployStartDate: null,
      SelectedInTheaterDate: null,
      selectedDeployEndLOA: null,

      // ------------ Textbox Fields
      selectedLastName: null,
      selectedFirstName: null,
      selectedSuffix: null,
      selectedMiddleName: null,
      selectedPassport: null,
      selectedEmail: null,
      selectedLoa: null,

      //--------------- Validation
      validationErrorsFound: false,
      lastNameUndefined: false,
      firstNameUndefined: false,
      passportUndefined: false,
      nationalityUndefined: false,
      contractUndefined: false,
      employerUndefined: false,
      deployStartUndefined: false,
      endNotGreaterThanStart: false,
      deployEndUndefined: false,
      loaUndefined: false,
      dodCivUndefined: false,

      //------------------- Verified Person
      showVerifiedPerson: false,
      verifiedPersonID: null,
      verfiedLastname: null,
      verfiedFirstName: null,
      verfiedContract: null,
    };
  },
  created() {

    // console.log('**** created ****');
    this.$data.createdHasBeenExecuted = true;
    this.captureRouterParameters ();
    this.getAllCompany();
    this.getAllUniqueContractNumbers();
    this.getAllCountry();
    this.setYesNoDefault();
   },
   mounted () {
    // console.log('this.UserProfileId = ',this.UserProfileId);
  },
   computed: {
    UserProfileId() {
      return store.authenticatedUser.userProfileId != null 
      ? store.authenticatedUser.userProfileId
      : store.tempUserProfileId;
    }, 
  },

  methods: {

    captureRouterParameters() {

      // console.log('captureRouterParameters(): this.$data.createdHasBeenExecuted = ', this.$data.createdHasBeenExecuted);

      this.$data.contractID = this.$route.params.contractId;
      this.$data.contractNumber = this.$route.params.contractNumber;

      // console.log('store.authenticatedUser: ', store.authenticatedUser);
      // console.log('captureRouterParameters(): this.$data.contractID = ', this.$data.contractID);
      // console.log('captureRouterParameters(): this.$data.contractNumber = ', this.$data.contractNumber);

      if (store.authenticatedUser.roleName == "Admin") {
        this.$data.userIsAdmin = true;
      } else {
        this.$data.userIsAdmin = false;
      }

      if (this.$data.contractID == -1) {
        this.$data.disableContractDdl = false;
      } else {
        this.$data.disableContractDdl = true;
      }

    },

    // ---------------- click events --------------------------------------------
    
    handleCreatePersonFunc() {
      // console.log('---- handleCreatePersonFunc() ----');

      this.validateFields();

      if (this.$data.validationErrorsFound == false) {
        this.createPerson();
        // this.clearForm();
      }
    },

    handleClearFunc() {
      // console.log('---- handleClearFunc() ----');
      this.clearForm();
    },

    handleHideResults() {
      this.$data.showVerifiedPerson = false;
    },

    clearForm(){
      // console.log('---- clearForm() ----');
      this.$data.selectedLastName = null;
      this.$data.selectedSuffix = null;
      this.$data.selectedMiddleName = null;
      this.$data.SelectedInTheaterDate = null;
      this.$data.SelectedDeployStartDate = null;
      this.$data.selectedFirstName = null;
      this.$data.selectedPassport = null;
      this.$data.selectedEmail = null;
      this.$data.selectedLoa = null;
      this.$data.selectedDeployEndLOA = null;

      //----- Lists

      if (this.$data.disableContractDdl == false) {
        this.$data.selectedContractID = this.$data.defaultContract.contractId;
      }

      this.$data.selectedCompanyId = this.$data.defaultCompany.companyId;
      this.$data.selectedNationalityID = this.$data.defaultCountry.countryId;

      this.$data.SelectedLoaawID = 1;
      this.$data.SelectedDodCivID = 2;

      this.clearValidationFields();
    },

    // ---------------- General Support --------------------------------------------

    formatDateFnc(value) {
      //Used to format dates passed to the HTML date control.
      let monthPart = value.substring(0, 2);
      let dayPart = value.substring(3, 5);
      let yearPart = value.substring(6, value.length);
      return yearPart + '-' + monthPart + '-' + dayPart;
    },

    // ---------------- createPerson  -----------------------------

    createPerson() {
      // console.log('--- createPerson() ---');

      let nullValue = null;

      let SPOTArmingValue = false;
      if (this.$data.SelectedLoaawID == 1) {
        SPOTArmingValue = true;
      } else {
        SPOTArmingValue = false;
      }

      let DodCivValue = false;
      if (this.$data.SelectedDodCivID == 1) {
        DodCivValue = true;
      } else {
        DodCivValue = false;
      }

      // console.log('-----<> this.$data.selectedEmail = ', this.$data.selectedEmail);

      let formData = new FormData();
      formData.append("UserProfileID",this.UserProfileId);
      formData.append("LastName",this.$data.selectedLastName);
      formData.append("FirstName",this.$data.selectedFirstName);
      formData.append("MiddleName",this.$data.selectedMiddleName);
      formData.append("NameSuffix",this.$data.selectedSuffix);
      formData.append("USN",this.$data.selectedPassport);
      formData.append("CountryId",this.$data.selectedNationalityID);
      formData.append("Email",this.$data.selectedEmail);
      formData.append("ContractId",this.$data.selectedContractID);
      formData.append("SPOTDTSID",this.$data.selectedLoa);
      formData.append("CompanyId",this.$data.selectedCompanyId);
      formData.append("SPOTArming",SPOTArmingValue);
      formData.append("DODCiv",DodCivValue);
      formData.append("InTheaterArrival",this.$data.SelectedInTheaterDate);
      formData.append("DeployStartDate",this.$data.SelectedDeployStartDate);
      formData.append("DeployEndDate",this.$data.selectedDeployEndLOA);
      formData.append("LastUpdateBy",this.UserProfileId);
      formData.append("CreateDate",nullValue);
      formData.append("LastUpdateDate",nullValue);

      // for (let value of formData.values()) {
      //   console.log('value = ', value);
      // }

      // for (let item of formData) {
      //   console.log('item = ', item);
      // }

      // console.log('-----------------------');

      axios
        .post(store.webAPIUrl + "Person/CreatePerson/",formData)
        .then((response) => response.data)
        .then((data) => {
          // console.log('data: ', data);
          this.$data.verifiedPersonID = data.personID;
          this.$data.verfiedLastname = data.lastName;
          this.$data.verfiedFirstName = data.firstName;
          this.$data.verfiedContract = data.contractNumber;
          this.$data.showVerifiedPerson = true;
        });
    },

    // ---------------- getAllCompany --------------------------------------------

    getAllCompany() {
      // console.log("ContractRecords.vue getAllCompany()");
      axios
        .get(store.webAPIUrl + "Company/SelAllCompany")
        .then((response) => response.data)
        .then((data) => {
          this.$data.companyList = data;

          //Add the default item to the top of the list.
          this.$data.companyList.unshift(this.$data.defaultCompany);
          //Make the selection for the dropdown list.
          this.$data.selectedCompanyId = this.$data.defaultCompany.companyId;

          // console.log('getAllCompany() - this.$data.companyList = ', this.$data.companyList);

        });
    },
    
    // ---------------- getAllContracts -----------------------------------------

    getAllUniqueContractNumbers() {
      // console.log("ContractRecords.vue getAllContracts()");
      // console.log('this.UserProfileId = ', this.UserProfileId);
      axios
        .get(store.webAPIUrl + "Contract/getContractForUserRole/" + this.UserProfileId)
        .then((response) => response.data)
        .then((data) => {
          this.$data.contractList = data;

          // console.log('this.$data.contractList = ', this.$data.contractList);

          if (this.$data.disableContractDdl == false) {

            //Add the default item to the top of the list.
            this.$data.contractList.unshift(this.$data.defaultContract);

            //Make the selection for the dropdown list.
            this.$data.selectedContractID = this.$data.defaultContract.contractId;
          } else {
            this.$data.selectedContractID = this.$data.contractID;
          }
        });
    },

    // ---------------- getAllCountry -------------------------------------------

    getAllCountry() {
      // console.log("ContractRecords.vue getAllCountry()");
      axios
        .get(store.webAPIUrl + "Country/SelAllCountry")
        .then((response) => response.data)
        .then((data) => {
          this.$data.nationalityList = data;

          //Add the default item to the top of the list.
          this.$data.nationalityList.unshift(this.$data.defaultCountry);
          //Make the selection for the dropdown list.
          this.$data.selectedNationalityID = this.$data.defaultCountry.countryId;

        });
    },

    // ---------------- setYesNoDefault -----------------------------------------

    setYesNoDefault() {
      this.$data.SelectedLoaawID = 1;
      this.$data.SelectedDodCivID = 2;
    },

    // ---------------- ValidteFields -------------------------------------------

    validateFields() {

      this.clearValidationFields();

      this.$data.lastNameUndefined = this.validateTextbox(this.$data.selectedLastName);
      this.$data.firstNameUndefined = this.validateTextbox(this.$data.selectedFirstName);
      this.$data.passportUndefined = this.validateTextbox(this.$data.selectedPassport);
      this.$data.nationalityUndefined = (this.$data.selectedNationalityID == -1);

      if (this.$data.disableContractDdl == true){
        this.$data.contractUndefined = false;  
      } else {
        this.$data.contractUndefined = (this.$data.selectedContractID == -1);
      }
      
      this.$data.employerUndefined = (this.$data.selectedCompanyId == -1);

      this.$data.deployStartUndefined = (this.$data.SelectedDeployStartDate == null);
      this.$data.deployEndUndefined = (this.$data.selectedDeployEndLOA == null);

      this.$data.loaUndefined = this.validateTextbox(this.$data.selectedLoa);
      this.$data.dodCivUndefined = (this.$data.SelectedDodCivID == -1);

      //----------------------------- Dates ---------------------

      let startDate = null;
      let endDate = null;

      if ((this.$data.SelectedDeployStartDate != null) && (this.$data.selectedDeployEndLOA != null)) {
        startDate = Date.parse(this.$data.SelectedDeployStartDate);
        endDate = Date.parse(this.$data.selectedDeployEndLOA);

        if (endDate <= startDate) {
          this.$data.endNotGreaterThanStart = true;
        }
      }


      this.$data.validationErrorsFound = 
      this.$data.lastNameUndefined  || this.$data.firstNameUndefined  || 
      this.$data.passportUndefined  || this.$data.nationalityUndefined  || 
      this.$data.contractUndefined  || this.$data.endNotGreaterThanStart ||
      this.$data.employerUndefined  || this.$data.deployStartUndefined  || 
      this.$data.deployEndUndefined || this.$data.loaUndefined  || 
      this.$data.dodCivUndefined;

      return false;
    },

    validateTextbox(fieldValue) {
      let errorfound = false;
      if (fieldValue == null) {
        errorfound = true;
      } else if (fieldValue.trim().length == 0) {
        errorfound = true;
      }
      return errorfound;
    },

    clearValidationFields() {
      this.$data.validationErrorsFound = false;
      this.$data.lastNameUndefined = false;
      this.$data.firstNameUndefined = false;
      this.$data.passportUndefined = false;
      this.$data.nationalityUndefined = false;
      this.$data.contractUndefined = false;
      this.$data.employerUndefined = false;
      this.$data.deployStartUndefined = false;
      this.$data.deployEndUndefined = false;
      this.$data.loaUndefined = false;
      this.$data.endNotGreaterThanStart = false;
      this.$data.dodCivUndefined = false;
      this.$data.showVerifiedPerson = false;
    },

  },
};
</script>

<style scoped>
/* ---------------------- Containers -------------------- */

.pagesMainDiv {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  padding-right: 0px;
  text-align: left;
  width: 100%;
}

.formContainer {
  display: grid;
  grid-template-columns: 50% 45%;
  width: 90%;
}

.leftRightRowContainer {
  display: grid;
  grid-template-columns: 30% 60%;
  grid-template-rows: repeat(7, 40px);
}

/* ---------------------- Buttons -------------------- */

.btnCreateProperties {
  margin-top: 15px;
  padding: 6px;
}

.tbdButtonLeftMargin {
  margin-left: 15px;
}

/* ---------------------- Controls -------------------- */

.ctrlBorderRadius {
  border: 1px solid #d9d9d9;
  border-radius: 0px;
}

.ctrlDropDown {
  height: 30px;
  padding: 5px;
}

.ctrlTextbox {
  height: 30px;
  padding: 5px;
}

.ctrlDate {
  height: 30px;
  padding: 5px;
}

.ctrlLabel {
  font-weight: bold;
  color: black;
}

.fontSizeAll {
  font-size: smaller;
}

.fontSizeBtn {
  font-size: 12px;
}

option:first-of-type {
  color: blue;
}

/* ---------------------- Page Header -------------------- */

.pageHeader {
  font-size: 24px;
  color: #000099;
}

/* ---------------------- Hor and Ver Alignment -------------------- */

.itemHorRightVerCenter {
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
}

.itemHorLeftVerCenter {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}

/* ---------------------- Borders -------------------- */
.borderRight {
  border-right: 1px solid white;
}

.borderBottom {
  border-bottom: 1px solid white;
}

/* ---------------------- Sizes -------------------- */

.ctrlSize27 {
  width: 200px;
}

.labelRightMargin {
  margin-right: 10px;
}

/* ---------------------- Validation -------------------- */

.validationDiv {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: center;

  border: 1px solid darkred;
  width: 550px;
  padding: 25px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.validationHeaderDiv {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: darkblue;
}

.validationErrorAsterisk {
  margin-left: 2px;
}

    .highlightRed {
        color: #DC143C;
    }
.highlightDarkRed {
  color: darkred;
}

.divRequiredInstructions {
  color: black;
  font-size: 12px;
  margin-left: 15px;
  margin-bottom: 15px;
  margin-top: 10px;
}

/* ---------------------- Validation Table -------------------- */

.valTableMargin {
  margin-top: 15px;
  margin: 0 auto;
}
.valCell {
  border-top: 1px #e6e6e6 solid;
  border-bottom: 1px #e6e6e6 solid;
  padding: 8px;
  text-align: left;
}
.valCellLeft {
  border-top: 1px #e6e6e6 solid;
  border-bottom: 1px #e6e6e6 solid;
  border-right: 1px #e6e6e6 solid;
  padding: 8px;
  font-weight: bold;
  color: blue;
  text-align: left;
}

</style>